import { ListItemIcon as MuiListItemIcon, type ListItemIconProps as MuiListItemIconProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<MuiListItemIconProps>;

export function ListItemIcon(props: Props) {
  return <MuiListItemIcon {...props} />;
}

export type { Props as ListItemIconProps };
